import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { LogoMark } from "./LogoMark";

export const Header = ({ onOrganizer }) => (
  <header
    data-testid="site-header"
    className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-3">
      <a href="#top" data-testid="logo-link" className="flex items-center gap-2.5 shrink-0">
        <LogoMark className="w-8 h-8" />
        <span className="font-display font-bold tracking-tight text-sm sm:text-base whitespace-nowrap">
          WanneerKaartverkoop<span className="text-volt">.nl</span>
        </span>
        <span className="relative hidden sm:flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-volt opacity-70" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-volt" />
        </span>
      </a>
      <div className="flex items-center gap-3 sm:gap-5">
        <Link
          to="/admin"
          data-testid="admin-panel-trigger"
          className="hidden sm:block font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500 hover:text-slate-200 transition-colors"
        >
          Admin
        </Link>
        <button
          onClick={onOrganizer}
          data-testid="header-organizer-button"
          className="inline-flex items-center gap-1.5 rounded-full border border-white/15 px-3.5 py-2 text-xs font-semibold text-slate-200 transition-colors hover:border-volt/60 hover:text-volt"
        >
          <Plus className="h-3.5 w-3.5" />
          Event aanmelden
        </button>
      </div>
    </div>
  </header>
);
